import React from 'react';
import { Star, Ticket, Building2 } from 'lucide-react';

const soldLabel = (n) => (n >= 10 ? `${Math.floor(n / 10) * 10}+` : `${n}`);

export const SalesProof = ({ company }) => {
  const sold = Number(company.tickets_sold) || 0;
  const rating = Number(company.google_rating) || 0;
  const reviews = Number(company.google_review_count) || 0;
  if (!sold && !rating) return null;
  const RatingTag = company.google_maps_url ? 'a' : 'span';
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2 text-sm" data-testid="sales-proof">
      {rating > 0 && (
        <RatingTag
          {...(company.google_maps_url ? { href: company.google_maps_url, target: '_blank', rel: 'noopener noreferrer' } : {})}
          className="inline-flex items-center gap-1.5 bg-white text-slate-900 font-semibold rounded-lg px-2.5 py-1 hover:bg-slate-100"
          data-testid="google-rating-badge">
          <Star className="w-4 h-4 fill-amber-400 text-amber-400" /> {rating.toFixed(1)}/5
          <span className="font-normal text-slate-500">Google{reviews > 0 ? ` · ${reviews.toLocaleString()} reviews` : ''}</span>
        </RatingTag>
      )}
      {sold > 0 && (
        <span className="inline-flex items-center gap-1.5 bg-emerald-500/90 text-white font-semibold rounded-lg px-2.5 py-1" data-testid="tickets-sold-badge">
          <Ticket className="w-4 h-4" /> {soldLabel(sold)} tickets sold
        </span>
      )}
    </div>
  );
};

const Row = ({ label, value, testid }) => (value ? (
  <div className="flex flex-col sm:flex-row sm:gap-4 py-2 border-b border-slate-100 last:border-0" data-testid={testid}>
    <dt className="sm:w-48 shrink-0 text-xs font-semibold uppercase tracking-wide text-slate-400">{label}</dt>
    <dd className="text-sm text-slate-800">{value}</dd>
  </div>
) : null);

export const ProviderInfo = ({ company }) => {
  const p = company.provider || {};
  return (
    <section className="max-w-5xl mx-auto px-5 mt-6" data-testid="provider-info">
      <div className="bg-white rounded-2xl border border-slate-200 p-5 sm:p-6">
        <h2 className="text-base md:text-lg font-semibold text-slate-900 flex items-center gap-2">
          <Building2 className="w-5 h-5 text-[#0C2159]" /> Provider information
        </h2>
        <p className="text-xs text-slate-500 mt-1">
          {p.seller_name ? 'Tickets for this attraction are sold by the ticket seller below.' : 'This product is offered by the attraction operator below.'}
        </p>
        <dl className="mt-4">
          <Row label={p.seller_name ? 'Attraction' : 'Operator'} value={p.name} testid="provider-name" />
          <Row label="Address" value={p.address} testid="provider-address" />
          <Row label="Phone" value={p.phone} testid="provider-phone" />
          <Row label="Email" value={p.email} testid="provider-email" />
          <Row label="Ticket seller" value={p.seller_name && `${p.seller_name}${p.seller_reg_no ? ` (${p.seller_reg_no})` : ''}`} testid="provider-seller" />
          <Row label="Ticketing platform" value="StayMii E-Ticket™" testid="provider-platform" />
        </dl>
      </div>
    </section>
  );
};
